import React from 'react';
import './App.scss';
import SnakeBoardComponent from './components/snake-board';

function App() {
  return (
    <div className="App">
      <SnakeBoardComponent></SnakeBoardComponent>
    </div>
  );
}

export default App;
